<template>
  <div>
    <p>{{ t("GenerateCatalogFromTextFile.CatalogNaming.Part1") }}</p>

    <p>
      <b-input id="catalog-naming-name" v-model="vm.newCatalogName" :class="{ 'border-danger': !catalogValidation.isValid }" @input="onInput" />
      <b-tooltip v-if="!catalogValidation.isValid" target="catalog-naming-name" :triggers="['hover']" noninteractive>
        {{ catalogValidation.errorMsg }}
      </b-tooltip>
    </p>

    <p class="mb-0">
      {{
        t("GenerateCatalogFromTextFile.CatalogNaming.Continue", {
          BackButton: t("Back"),
          ContinueButton: t("Continue")
        })
      }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { watch, reactive, computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits<{
  (e: "change", payload: { name: string; isValid: boolean }): void;
}>();

//#region ViewModel
type ViewModel = {
  newCatalogName: string | null;
  errorMsg: string | null;
};

const vm = reactive<ViewModel>({
  newCatalogName: "",
  errorMsg: ""
});

const maxStringLength = 256;

const catalogValidation = computed(() => {
  const name = vm.newCatalogName?.trim() || "";

  let errorMsg = "";
  let isValid = true;

  if (name.length <= 0) {
    isValid = false;
    errorMsg = t("ErrorMessage.Mandatory");
  } else if (name.length > maxStringLength) {
    isValid = false;
    errorMsg = t("ErrorMessage.Max256");
  }

  return {
    isValid,
    errorMsg
  };
});

const onInput = () => {
  if (vm.newCatalogName !== null) {
    emit("change", {
      name: vm.newCatalogName,
      isValid: catalogValidation.value.isValid
    });
  }
};

watch(
  () => vm.newCatalogName,
  () => {
    onInput();
  }
);
</script>
